import * as React from "react";
import {FormGroupProps} from "../../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../../common/props/PlaceholderProps";
import {option, Option} from "ts-option";
import SelectStatusCategory, {StatusCategoryType} from "./SelectStatusCategory";
import FormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/FormGroup";

interface ComponentProps {
	/**
	 * List of items.
	 */
	items: StatusCategoryType[];
}

type Props = FormGroupProps<string> & PlaceholderProps & ComponentProps;

/**
 * Select lead/job status category form view group.
 */
export default class SelectStatusCategoryFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<SelectStatusCategory placeholder={this.props.placeholder}
									  selectedId={this.props.field.getOptionalValue()}
									  onChanged={this.onChange}
									  items={option(this.props.items)}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on category change.
	 * @param data
	 */
	onChange(data: Option<StatusCategoryType>) {
		this.props.onChange(this.props.field.updateValue(data.map(d => d.value)));
	}
}
